import { useEffect, useState } from "react";
import api from "@/lib/api";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ProgramCard from "@/components/ProgramCard";
import { MaskedLines } from "@/components/Reveal";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/programs").then((r) => setPrograms(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="relative bg-soma-bg min-h-screen">
      <Nav />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-40 pb-16">
        <span className="text-xs uppercase tracking-[0.35em] text-soma-primary">The catalog</span>
        <h1 className="font-display font-semibold text-4xl lg:text-6xl mt-6 leading-[0.9] tracking-tight">
          <MaskedLines lines={["Every protocol,", "engineered for", "a state of mind."]} />
        </h1>
        <p className="mt-8 text-soma-muted max-w-xl text-lg">Subscription training programs built on closed-loop neurofeedback. Cancel anytime.</p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-32" data-testid="programs-grid">
        {loading ? (
          <div className="text-soma-muted py-20">Loading programs…</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {programs.map((p, i) => <ProgramCard key={p.id} program={p} index={i} />)}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
